<template>
  <el-dialog
    :model-value="visible"
    title="Nueva API Key"
    width="500px"
    @close="handleClose"
  >
    <custom-input
      v-model="apiKey.Descripcion"
      label="Descripción"
      :settings="{ placeholder: 'Ingrese una descripción para la API Key' }"
    />
    <template #footer>
      <el-button @click="handleClose">Cancelar</el-button>
      <el-button
        type="primary"
        :disabled="apiKey.Descripcion === null || apiKey.Descripcion.trim().length === 0"
        @click="handleSubmit"
      >
        Generar API Key
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useApiKeysStore } from './apiKeys_store';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import CustomInput from '@/shared/components/custom_input.vue';

const apiKeysStore = useApiKeysStore();
const { apiKey } = storeToRefs(apiKeysStore);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'created']);

const handleClose = () => {
  emit('close');
};

const handleSubmit = async () => {
  try {
    if (!apiKey.value.Descripcion || apiKey.value.Descripcion.trim().length === 0) return;

    useLoading().openLoading();
    await apiKeysStore.createApiKeyHTTP();
    useMessageSuccess().open('API Key generada exitosamente');
    emit('created');
    handleClose();
  } catch (error) {
    useMessageError().open(error);
  } finally {
    useLoading().closeLoading();
  }
};
</script>
